import script from "./UserMyCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMyCode.vue?vue&type=script&setup=true&lang=js"

import "./UserMyCode.vue?vue&type=style&index=0&id=06f2733b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f2733b"]])

export default __exports__